import React, { useEffect } from "react";
import "./App.css";
import Homepage from "./pages/Homepage";
import GameIndex from "./pages/GameIndex";
import VsScreen from "./components/game/VsScreen";
import StatScreen from "./components/game/StatScreen";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import "@solana/wallet-adapter-react-ui/styles.css";
import * as AWS from 'aws-sdk'
import * as anchor from "@project-serum/anchor";

const configuration = {
  region: 'us-east-1',
  secretAccessKey: 'pbB5rUOe7+2ECT1fiDMQYp0DA0PJWPRFtejv92Ag',
  accessKeyId: 'AKIAWENPZQUFICV7X77K'
}

AWS.config.update(configuration);
var ddb = new AWS.DynamoDB.DocumentClient();

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;

const connection = new anchor.web3.Connection(
  rpcHost ? rpcHost : anchor.web3.clusterApiUrl("mainnet-beta")
);

const getCandyMachineId = (): anchor.web3.PublicKey | undefined => {
  try {
    const candyMachineId = new anchor.web3.PublicKey(
      process.env.REACT_APP_CANDY_MACHINE_ID!
    );

    return candyMachineId;
  } catch (e) {
    console.log("Failed to construct CandyMachineId", e);
    return undefined;
  }
};

const candyMachineId = getCandyMachineId();
const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);
const txTimeoutInMilliseconds = 30000;


const App = () => {
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
      <Route path="/" element={<Homepage 
            candyMachineId={candyMachineId}
            connection={connection}
            startDate={startDateSeed}
            txTimeout={txTimeoutInMilliseconds}
            rpcHost={rpcHost}
        />} />
        <Route path="/game" element={<GameIndex
            candyMachineId={candyMachineId}
            connection={connection}
            startDate={startDateSeed}
            txTimeout={txTimeoutInMilliseconds}
            rpcHost={rpcHost}
         />} />

        <Route path="/vs" element={<VsScreen
            candyMachineId={candyMachineId}
            connection={connection}
            startDate={startDateSeed}
            txTimeout={txTimeoutInMilliseconds}
            rpcHost={rpcHost}
        />} />

        <Route path="*" element={<Homepage 
            candyMachineId={candyMachineId}
            connection={connection}
            startDate={startDateSeed}
            txTimeout={txTimeoutInMilliseconds}
            rpcHost={rpcHost}
        />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
